import FunctionHelper from "../../shared/helper/FunctionHelper";
import LengthUnit from "../../shared/units/LengthUnit";
import StorageItem from "../../shared/StorageItem";

export default class UserSettings {
	public disableCertificateHints: boolean; // show certificate hints
	public unit: LengthUnit;

	constructor(data?: any) {
		this.disableCertificateHints = FunctionHelper.applyValue(data?.disableCertificateHints, false);
		let unitDefault: LengthUnit | string = FunctionHelper.applyValue(
			localStorage.getItem(StorageItem.UNIT), LengthUnit.MILLIMETER
		);
		this.unit = FunctionHelper.applyValue(data?.unit, unitDefault);
	}

	public static fromJson(data: any): UserSettings {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new UserSettings(data);
	}

	public toJson(): any {
		return {
			'disableCertificateHints': this.disableCertificateHints,
			'unit': this.unit
		};
	}

	public clone(): UserSettings {
		return UserSettings.fromJson(this.toJson());
	}
}